import ApisService from './index'
import { IPricingCurrencyAdd } from '../interfaces/productPricingInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

//  Tạo báo giá
export function createProductPricing(data: any) {
  try {
    return ApisService.post('/dontim/create-dontim', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function createProductPricingCurrency(data: IPricingCurrencyAdd) {
  try {
    return ApisService.post('/dontim/create-dontim-tiente', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

// tính giá vốn
export function getCapitalPriceProductPricing(data: IPricingCurrencyAdd) {
  try {
    return ApisService.post('/dontim/' + data.id + '/tinhgiavon-dontim', {...data, uuid: ""})
  } catch (err) {
    handleError(err)
    throw err
  }
}

// cập nhật báo giá
export function updateProductPricing(data: any) {

 
  try {
    return ApisService.put('/dontim/' + data.id + '/update-dontim', {...data, uuid: ""})
  } catch (err) {
    handleError(err)
    throw err
  }
}

// get chi tiết báo giá, đơn mua tie
export function getDetailProductPricing(id: string) {
  try {
    return ApisService.get('/dontim/' + id + '/get-chitiet-dontim')
  } catch (err) {
    handleError(err)
    throw err
  }
}

// get chi tiết báo giá, đơn mua
export function getDetailProductPricingByUuid(uuid: string) {
  try {
    return ApisService.get('/dontim/' + uuid + '/get-chitiet-dontim-by-uuid')
  } catch (err) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách báo giá, đơn mua
export function getListProductPricing(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/dontim/filter-dontim', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteProductPricing(id: string) {
  try {
    return ApisService.delete('/dontim/' + id + '/delete-dontim')
  } catch (err) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách yêu cầu tìm cần báo giá
export function getListSearchRQ(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/yeucautim/filter-yeucautim', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

// chốt báo giá
export function updateProductPricingConfirm(id: string) {
  try {
    return ApisService.put('/dontim/' + id + '/chotbaogia')
  } catch (err) {
    handleError(err)
    throw err
  }
}

// tính giá vốn
export function getListReportCapitalPrice(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/dontim/baocao-giavon', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}


// 
export function lockSearchRequest(donTimYeuCauTimId: string) {
  try {
    return ApisService.put('/dontim/' + donTimYeuCauTimId + '/lock-dontim')
  } catch (err) {
    handleError(err)
    throw err
  }
}
export function unLockSearchRequest(donTimYeuCauTimId: string) {
  try {
    return ApisService.put('/dontim/' + donTimYeuCauTimId + '/unlock-dontim')
  } catch (err) {
    handleError(err)
    throw err
  }
}


